// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fy-0";